
<template>
<div>
    <b-form @submit="SaveCustomerList">
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
        <div class="box box-primary">
          <div class="box-header">
              <h3 class="box-title">{{$t('customer.profile_company')}}</h3>
          </div>

          <!-- Company Profile -->
          <div class="box-body">

              <div v-show="true" class="row" style="margin-top:5px;">
                <!-- [Company Name] -->
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="company_name" >{{$t('customer.company_name')}}</label>
                        <b-form-input type="text" :required="ischeck" class="form-control" v-model="customerdata.company_name" id="company_name" :placeholder="$t('customer.company_name')" />
                    </div>
                </div>
                <!-- /[Company Name] -->

                <!-- [Company Address] -->
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="company_address">{{$t('customer.company_address')}}</label>
                        <b-form-input v-model="customerdata.company_address" type="text" :required="ischeck" class="form-control" id="company_address" :placeholder="$t('customer.company_address')" />
                    </div>
                </div>
                <!-- /[Company Address] -->

                <!-- [Company Tax Code] -->
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="company_tax_code">{{$t('customer.company_tax_code')}}</label>
                        <b-form-input v-model="customerdata.company_tax_code" type="number" :required="ischeck" class="form-control" id="company_tax_code" :placeholder="$t('customer.company_tax_code')" />
                    </div>
                </div>
                <!-- /[Company Tax Code] -->
              </div>
              <!-- /row -->

              <div class="row">
                <!-- [company_email] -->
                <div class="col-md-4">
                    <div class="form-group required">
                        <label class="control-label" for="company_email" >{{$t('customer.company_email')}}</label>
                        <input v-model="customerdata.company_email" type="email" class="form-control" id="company_email" placeholder="example@example.com">
                        <span v-if="this.field_required.company_email != ''" class="help is-danger">
                            <font color="red">{{ $t(field_required.company_email) }}</font>
                        </span>
                    </div>
                </div>
                <!-- /[company_email] -->

                <!-- [company_phone] -->
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="company_phone">{{$t('customer.company_phone')}}</label>
                        <input v-model="customerdata.company_phone" type="text" class="form-control" id="company_phone" :placeholder="$t('customer.company_phone')" >
                    </div>
                </div>
                <!-- /[company_phone] -->

                <!-- [company_website] -->
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="company_website">{{$t('customer.company_website')}}</label>
                        <input v-model="customerdata.company_website" type="text" class="form-control" id="company_website" :placeholder="$t('customer.company_website')" >
                    </div>
                </div>
                <!-- /[company_website] -->
              </div>
              <!-- /row -->

          </div>
        </div>
        <!-- /box box-primary -->

        <!-- box box-primary Legal Representation-->
        <div class="box box-primary">
          <div class="box-header">
            <h3 class="box-title">{{$t('customer.legal_representation')}}</h3>
          </div>
          <div class="box-body">
            <div class="row">

              <!-- /representative_name -->
              <div class="col-md-4">
                <div class="form-group">
                  <label for="representative_name">{{$t('customer.representative_name')}}</label>
                  <input v-model="customerdata.representative_name" type="text" class="form-control" id="representative_name" :placeholder="$t('customer.representative_name')">
                </div>
              </div>
              <!-- /representative_name -->

              <!-- [representative_email] -->
              <div class="col-md-4">
                  <div class="form-group required">
                      <labe class="control-label" for="representative_email">{{$t('customer.representative_email')}}</labe>
                      <input @input="validateFieldIsEmpty('representative_email')" v-model="customerdata.representative_email" type="email" class="form-control" id="representative_email" placeholder="example@example.com">
                  </div>
                  <span v-if="this.field_required.representative_email != ''" class="help is-danger">
                        <font color="red">{{ $t(field_required.representative_email) }}</font>
                    </span>
              </div>
              <!-- /[representative_email] -->

              <!-- [representative_phone] -->
              <div class="col-md-4">
                  <div class="form-group">
                      <label for="representative_phone">{{$t('customer.representative_phone')}}</label>
                      <input v-model="customerdata.representative_phone" type="text" class="form-control" id="representative_phone" :placeholder="$t('customer.representative_phone')" >
                  </div>
              </div>
              <!-- /[representative_phone] -->
            </div>
            <!-- /row -->

            <div class="row">

              <!-- [representative_identificationnumber] -->
              <div class="col-md-4">
                <div class="form-group">
                  <label for="representative_identificationnumber">{{$t('customer.representative_identificationnumber')}}</label>
                  <b-form-input v-model="customerdata.representative_identificationnumber" type="number" :required="ischeck" class="form-control" id="representative_identificationnumber" :placeholder="$t('customer.representative_identificationnumber')" />
                </div>
              </div>
              <!-- /[representative_identificationnumber] -->

              <!-- [representative_passport] -->
              <div class="col-md-4">
                <div class="form-group">
                  <label for="representative_passport">{{$t('customer.representative_passport')}}</label>
                  <input v-model="customerdata.representative_passport" type="text" class="form-control" id="representative_passport" :placeholder="$t('customer.representative_passport')">
                </div>
              </div>
              <!-- /[representative_passport] -->

              <!-- [representative_position] -->
              <div class="col-md-4">
                <div class="form-group">
                  <label for="representative_position">{{$t('customer.representative_position')}}</label>
                  <input v-model="customerdata.representative_position" type="text" class="form-control" id="representative_position" :placeholder="$t('customer.representative_position')">
                </div>
              </div>
              <!-- /[representative_position] -->
            </div>
            <!-- /row -->
          </div>
        </div>

        <!-- Contacter-->
        <div class="box box-primary">
            <div class="box-header">
                <h3 class="box-title">{{$t('customer.contacter')}}</h3>
            </div>
            <div class="box-body">
                <div class="row">
                    <!-- userName -->
                    <div class="col-md-4">
                        <div class="form-group required">
                            <label class="control-label" for="last_name">{{$t('customer.lastname')}}</label>
                            <input
                                v-model="customerdata.last_name"
                                type="text"
                                class="form-control"
                                id="last_name"
                                :placeholder="$t('customer.lastname')"
                                @input="validateFieldIsEmpty('last_name')"
                            >

                            <span v-if="this.field_required.last_name != ''" class="help is-danger">
                                <font color="red">{{ $t(field_required.last_name) }}</font>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group required">
                            <label class="control-label" for="first_name">{{$t('customer.firstname')}}</label>
                            <input
                                v-model="customerdata.first_name"
                                type="text"
                                class="form-control"
                                id="first_name"
                                :placeholder="$t('customer.firstname')"
                                @input="validateFieldIsEmpty('first_name')"
                            >

                            <span v-if="this.field_required.first_name != ''" class="help is-danger">
                                <font color="red">{{ $t(field_required.first_name) }}</font>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="company_tax_code">{{$t('customer.identificationnumber')}}</label>
                            <b-form-input v-model="customerdata.identificationnumber" type="number" :required="ischeck" class="form-control" id="identificationnumber" :placeholder="$t('customer.identificationnumber')" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="passport">{{$t('customer.passport')}}</label>
                            <input pattern="^(\w*(\d+[A-Z]|[A-Z]+\d)\w*)+$" title="'Passport' là chuỗi bao gồm ký tự và chữ số, A..Z và 0..9, ký tự phải viết hoa, chiều dài chuỗi lớn hơn 7 và nhỏ hơn 15" v-model="customerdata.passport" type="text" class="form-control" id="passport" :placeholder="$t('customer.passport')">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group required">
                            <label class="control-label" for="email">{{$t('customer.email')}}</label>
                            <input
                                :disabled="customerdata.id > 0"
                                v-model="customerdata.email"
                                type="email"
                                class="form-control"
                                id="email"
                                placeholder="example@example.com"
                                @input="validateEmailAll('email')"
                            >

                            <span v-if="this.field_required.email != ''" class="help is-danger">
                                <font color="red">{{ $t(field_required.email) }}</font>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="phone">{{$t('customer.phone')}}</label>
                            <input
                                v-model="customerdata.phone"
                                type="text"
                                class="form-control"
                                id="phone"
                                :placeholder="$t('customer.phone')"
                            >
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group required">
                            <label class="control-label" for="gender">{{$t('customer.gender')}}</label>
                            <select v-model="customerdata.gender" class="form-control" id="gender">
                                <option value="0">Female</option>
                                <option value="1">Male</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="dob">{{$t('customer.dob')}}</label>
                            <date-picker class="form-control" v-model="customerdata.dob" :config="options" id="dob"></date-picker>
                        </div>
                    </div>
                        <div class="col-md-4">
                            <div class="form-group required">
                                <label class="control-label" for="username">{{$t('customer.username')}}</label>
                                <input
                                    v-model="customerdata.username"
                                    type="text"
                                    class="form-control"
                                    id="username"
                                    :placeholder="$t('customer.username')"
                                    v-bind:disabled="this.customerdata.id != 0"
                                    @input="validateFieldIsEmpty('username')"
                                >

                                <span v-if="this.field_required.username != ''" class="help is-danger">
                                    <font color="red">{{ $t(field_required.username) }}</font>
                                </span>
                            </div>
                        </div>
                    </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group required" v-if="showPasswordText == true">
                            <label for="password" class="control-label">{{$t('customer.password')}}</label>
                            <input
                                v-model="customerdata.password"
                                @input="validatePassword(customerdata.password)"
                                type="password"
                                class="form-control"
                                id="password"
                                :placeholder="$t('customer.password')"
                            >
                            <span :class="{ password_length_count : valid_password_length, show_password_length : password_typed }"
                                class="password_length"
                            >{{ password_length }}</span>

                            <span v-if="this.field_required.password != ''" class="help is-danger">
                                <font color="red">{{ $t(field_required.password) }}</font>
                            </span>

                            <div v-show="password_typed" class="lnu_container">
                                <p :class="{ got_lowercase : contain_lowercase}">{{$t('customer.lowercase')}}</p>
                                <p :class="{ got_number : contain_number }">{{$t('customer.digit')}}</p>
                                <p :class="{ got_uppercase : contain_uppercase }">{{$t('customer.uppercase')}}</p>
                            </div>
                        </div>
                        <div class="form-group" v-else>
                            <label for="password">{{$t('customer.password')}}</label>
                            <div>
                                <b-button v-if="isCurrentUser" class="form-control" variant="primary" @click="showModal">{{$t('customer.password_modal[0].title')}}</b-button>
                                <b-button v-else class="form-control" variant="primary" @click="passwodReset">{{$t('customer.password_modal[0].title_reset')}}</b-button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="country">{{$t('customer.country')}}</label>
                            <b-form-select
                                :options="country_list"
                                v-model="customerdata.country_code"
                                class="form-control"
                            />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group required">
                            <label class="control-label" for="groups">{{$t('customer.group')}}</label>
                            <select disabled v-model="customerdata.groups" class="form-control" id="groups">
                                <option value="1">Admin</option>
                                <option value="2">Mod</option>
                                <option value="3">Staff</option>
                                <option value="4">Customer</option>
                                <option value="5">Operator</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group required">
                            <label class="control-label" for="dob">{{$t('customer.privilege')}}</label>
                            <select v-model="customerdata.privilege" class="form-control" id="privilege">
                                <option
                                v-for="option in GET_MEMBERROLECODES_DATA"
                                v-bind:value="option.id"
                                :key="option.id"
                                >{{ option.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4" v-show = "false">
                        <div class="form-group">
                            <label for="cromcode">{{$t('customer.crmcode')}}</label>
                            <input
                                v-model="customerdata.crmcode"
                                type="text"
                                class="form-control"
                                id="cromcode"
                                :placeholder="$t('customer.crmcode')"
                            >
                        </div>
                    </div>
                    <div class="col-md-4" v-show = "false">
                        <div class="form-group">
                            <label for="personal_tax_code">{{$t('customer.personal_tax_code')}}</label>
                            <b-form-input v-model="customerdata.personal_tax_code" type="number" :required="ischeck" class="form-control" id="personal_tax_code" :placeholder="$t('customer.personal_tax_code')" />
                        </div>
                    </div>
                    <div class="col-md-12" v-show = "false">
                        <label class>
                            <div
                            class="icheckbox_minimal-blue"
                            :class="{checked: customerdata.is_company}"
                            style="position: relative;"
                            >
                            <input
                                type="checkbox"
                                @click="isCheck"
                                class="minimal"
                                style="position: absolute; opacity: 0;"
                            >
                            </div>
                            &nbsp;{{$t('customer.is_company')}}
                        </label>
                    </div>
                </div>
                <b-button ref="formsubmitbutton" type="submit" variant="primary" style="display: none;">{{$t('common.submit')}}</b-button>
            </div>
        </div>
    </b-form>
    <!-- /.box-body -->
    <div class="box-footer">
        <button
        type="button"
        class="btn btn-primary"
        @click="onCurrentService"
        v-if="assignShow"
      >{{$t('customer.services')}}</button>

        <button
        type="button"
        class="btn btn-primary"
        @click="onOpenServices"
        v-if="assignShow"
      >{{$t('customer.services_history')}}</button>
        <button
        type="button"
        class="btn btn-labeled btn-danger"
        @click="CancelCustomerList"
        style="margin-right: 5px;"
      >
        <span class="btn-label">
          <i class="glyphicon glyphicon-remove"></i>
        </span>
        {{$t('common.cancel')}}
      </button>
        <button
        type="button"
        class="btn btn-labeled btn-success pull-right"
        @click="onSave"
        style="margin-right: 5px;"
      >
        <span class="btn-label">
          <i class="glyphicon glyphicon-ok"></i>
        </span>
        {{$t('common.save')}}
      </button>
        <!-- Only show with admin -->
        <button v-show="this.GET_ACCOUNT_DATA.privilege_id == 2 && parseInt(this.$route.params.id) == 0 ? false : true"
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="clickOpenModalChangeEmail"
            style="margin-right: 5px;"
        >
            <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{$t('common.change_email')}}
        </button>
    </div>

    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <router-view></router-view>
    <!-- Modal Component -->
    <div class="modal fade" id="modal-newpassword">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
                    <h1 class="modal-title">{{$t('customer.password_modal[0].title')}}</h1>
                    <p style="margin-top: 30px">{{$t('customer.password_modal[0].guide')}}</p>
                </div>
                <div class="modal-body">
                    <b-form>
                        <b-form-group :label="$t('customer.password_modal[0].oldpass')">
                            <b-form-input type="password" v-model="oldPassword" :placeholder="$t('customer.password_modal[0].enteroldpass')" />
                        </b-form-group>
                        <b-form-group :label="$t('customer.password_modal[0].newpass')">
                            <b-form-input type="password" v-model="newPassword" :placeholder="$t('customer.password_modal[0].enternewpass')" @input="validatePassword(newPassword)" />
                            <span :class="{ password_length_count : valid_password_length, show_password_length : password_typed }"
                                    class="password_length_modal"
                            >{{ password_length }}</span>

                            <div v-show="password_typed" class="lnu_container">
                                <p :class="{ got_lowercase : contain_lowercase}">{{$t('customer.password_modal[0].lowercase')}}</p>
                                <p :class="{ got_number : contain_number }">{{$t('customer.password_modal[0].digit')}}</p>
                                <p :class="{ got_uppercase : contain_uppercase }">{{$t('customer.password_modal[0].uppercase')}}</p>
                            </div>

                        </b-form-group>
                        <b-form-group :label="$t('customer.password_modal[0].confirmnewpass')">
                            <b-form-input type="password" v-model="confirmNewPassword" :placeholder="$t('customer.password_modal[0].enternewpassconfirm')" />
                        </b-form-group>

                        <b-button ref="formsubmitbutton_changepassword" type="submit" variant="primary" style="display: none;">{{$t('customer.password_modal[0].btn[0]')}}</b-button>
                    </b-form>
                </div>
                <div class="modal-footer">
                    <!-- <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >{{$t('customer.password_modal[0].btn[2]')}}</button> -->
                    <button
              type="button"
              class="btn btn-primary pull-left"
              @click="onUpdatePassword"
            >{{$t('customer.password_modal[0].btn[1]')}}</button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <!-- Inform modal -->
    <div class="modal modal-default" id="inform_modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
                    <h4 class="modal-title">{{$t('customer.inform_modal[0].title')}}</h4>
                </div>
                <div class="modal-body">
                    <h5 class="modal-title">{{$t(modal_title)}}</h5>
                </div>
                <div class="modal-footer">
                    <button
          type="button"
          class="btn btn-default pull-right"
          data-dismiss="modal"
        >{{$t('customer.inform_modal[0].modal_btn[0].close')}}</button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->


    <!-- //////////////////////////////////////////modal-change-email/////////////////////////////////////////////////////////// -->
    <!-- modal-change-email -->
    <div class="modal modal-default" id="modal-change-email">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h1 class="modal-title">{{$t('user.change_email_modal[0].title')}}</h1>
            <!-- <p style="margin-top: 30px">{{$t('user.password_modal[0].guide')}}</p> -->
          </div>
          <div class="modal-body">
            <b-form>
              <b-form-group :label="$t('user.change_email_modal[0].old_email')">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      :type="OldEmailFieldType"
                      v-model="oldEmail"
                      :placeholder="$t('user.change_email_modal[0].enter_old_email')"
                      class="form-control"
                      :disabled="true"
                    />
                    <span class="input-group-btn">
                      <button class="btn btn-default" type="button" >
                        <i :class="iconFieldTypeOldEmail" />
                      </button>
                    </span>
                  </div>
                </div>
              </b-form-group>

              <b-form-group :label="$t('user.change_email_modal[0].new_email')">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      :type="NewEmailFieldType"
                      @input="validateEmail(newEmail)"
                      v-model="newEmail"
                      :placeholder="$t('user.change_email_modal[0].enter_new_email')"
                      class="form-control"
                      style="z-index:0"
                    />
                    <span class="input-group-btn">
                      <button class="btn btn-default" type="button">
                        <i :class="iconFieldTypeNewEmail" />
                      </button>
                    </span>

                    <span v-if="this.newEmail != ''" class="help is-danger">
                      <font color="red">{{ $t(field_required.email) }}</font>
                    </span>
                  </div>
                </div>
              </b-form-group>

              <b-button
                ref="formsubmitbuttonsendmail"
                type="submit"
                variant="primary"
                style="display: none;"
              >{{$t('user.change_email_modal[0].btn[0]')}}</b-button>
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary pull-left"
              @click="onUpdateEmail"
            >{{$t('user.change_email_modal[0].btn[1]')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- ////////////////////////////////////////////modal-change-email///////////////////////////////////////////////////////// -->
</div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from "moment";
import Loading from "vue-loading-overlay";
import {
    mapGetters,
    mapActions
} from "vuex";
import utils from '@/lib/utils';
import constantsData from '@/lib/constantsData';

export default {
    name: "CustomerAddCompany",
    props: {
        customer_id: {
            type: Number,
            default: () => {
                return 0
            }
        },
        callback: {
            type: String
        },
    },
    data() {
        return {
            ischeck: false,
            assignShow: false,
            actionType: "",
            timeCurrent: "2019-01-16T06:00:00Z",
            customerdata: {
                id: 0,
                password: constantsData.password_default.password,
                last_login: this.timeCurrent,
                is_superuser: false,
                username: "",
                first_name: null,
                last_name: null,
                email: null,
                is_staff: false,
                is_active: true,
                date_joined: this.timeCurrent,
                groups: 4,
                privilege: 9,
                dob: "01-01-1990",
                phone: "",
                gender: 1,
                crmcode: "",
                country_code: 287,
                company_name: "",
                company_address: "",
                company_tax_code: null,
                company_email: null,
                company_phone: "",
                personal_tax_code: null,

                company_website: null,
                representative_name: null,
                representative_email: null,
                representative_phone: "",
                representative_identificationnumber: null,
                representative_passport: null,
                representative_position: null,

                is_company: 1,
                url_avatar: "",
                identificationnumber: "",
                passport: "",
            },
            options: {
                format: "DD-MM-YYYY",
                useCurrent: false,
                maxDate: moment().subtract(2, "days"),
            },
            country_list: [],
            showPasswordText: true,
            oldPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            password_length: 0,
            password_typed: false,
            contain_lowercase: false,
            contain_uppercase: false,
            contain_number: false,
            valid_password_length: false,
            valid_password: false,
            modal_title: "",

            field_required:{
                'last_name': '',
                'first_name': '',
                'email':'',
                'username':'',
                'password':'',
                "company_email":"",
                "representative_email":""
            },

            objectNameData: 'this.customerdata.',
            objectNameRequire: 'this.field_required.',
            isLoading:false,
            isCurrentUser: false,

            // #615
            OldEmailFieldType: "email",
            NewEmailFieldType: "email",
            oldEmail: "",
            newEmail: "",
            iconFieldTypeOldEmail: "glyphicon glyphicon-envelope",
            iconFieldTypeNewEmail: "glyphicon glyphicon-envelope",
            valid_email: false
        };
    },

    watch: {
        // watch customer detail
        CUSTOMER_DETAIL_DATA: function () {
            this.customerdata.password = this.CUSTOMER_DETAIL_DATA.password;
            this.customerdata.username = this.CUSTOMER_DETAIL_DATA.username;
            this.customerdata.first_name = this.CUSTOMER_DETAIL_DATA.first_name;
            this.customerdata.last_name = this.CUSTOMER_DETAIL_DATA.last_name;
            this.customerdata.email = this.CUSTOMER_DETAIL_DATA.email;

            // alway reset password #553
            // if(this.GET_ACCOUNT_DATA.email == this.CUSTOMER_DETAIL_DATA.email){
            //     this.isCurrentUser = true;
            // }

            if (this.CUSTOMER_DETAIL_DATA.profile === undefined) {
                this.customerdata.phone = "";
                this.customerdata.dob = null;
                this.customerdata.gender = 0;
                this.customerdata.crmcode = "";
                this.customerdata.country_code = "";
                this.customerdata.company_name = "";
                this.customerdata.company_address = "";
                this.customerdata.company_tax_code = "";
                this.customerdata.company_email = "";
                this.customerdata.company_phone = "";
                this.customerdata.personal_tax_code = "";
                this.customerdata.is_company = 1;

                this.customerdata.company_website = "";
                this.customerdata.representative_name = "";
                this.customerdata.representative_email = "";
                this.customerdata.representative_phone = "";
                this.customerdata.representative_identificationnumber = "";
                this.customerdata.representative_passport = "";
                this.customerdata.representative_position = "";

                this.customerdata.identificationnumber = "";
                this.customerdata.passport = "";

            } else {
                this.customerdata.phone = utils.formatPhoneWithSpace(this.CUSTOMER_DETAIL_DATA.profile.phone, "");
                this.customerdata.dob = utils.formatSqlDate(this.CUSTOMER_DETAIL_DATA.profile.dob, null, "DD-MM-YYYY");
                this.customerdata.gender = this.CUSTOMER_DETAIL_DATA.profile.gender;
                this.customerdata.crmcode = this.CUSTOMER_DETAIL_DATA.profile.customer_crm_code;
                this.customerdata.country_code = this.CUSTOMER_DETAIL_DATA.profile.country_code;
                this.customerdata.company_name = this.CUSTOMER_DETAIL_DATA.profile.company_name;
                this.customerdata.company_address = this.CUSTOMER_DETAIL_DATA.profile.company_address;
                this.customerdata.company_tax_code = this.CUSTOMER_DETAIL_DATA.profile.company_tax_code;
                this.customerdata.company_email = this.CUSTOMER_DETAIL_DATA.profile.company_email;
                this.customerdata.company_phone = utils.formatPhoneWithSpace(this.CUSTOMER_DETAIL_DATA.profile.company_phone, "");
                this.customerdata.personal_tax_code = this.CUSTOMER_DETAIL_DATA.profile.personal_tax_code;
                this.customerdata.is_company = this.CUSTOMER_DETAIL_DATA.profile.is_company;

                this.customerdata.company_website = this.CUSTOMER_DETAIL_DATA.profile.company_website;
                this.customerdata.representative_name = this.CUSTOMER_DETAIL_DATA.profile.representative_name;
                this.customerdata.representative_email = this.CUSTOMER_DETAIL_DATA.profile.representative_email;
                this.customerdata.representative_phone = utils.formatPhoneWithSpace(this.CUSTOMER_DETAIL_DATA.profile.representative_phone, "");
                this.customerdata.representative_identificationnumber = this.CUSTOMER_DETAIL_DATA.profile.representative_identificationnumber;
                this.customerdata.representative_passport = this.CUSTOMER_DETAIL_DATA.profile.representative_passport;
                this.customerdata.representative_position = this.CUSTOMER_DETAIL_DATA.profile.representative_position;

                this.customerdata.identificationnumber = this.CUSTOMER_DETAIL_DATA.profile.identificationnumber;
                this.customerdata.passport = this.CUSTOMER_DETAIL_DATA.profile.passport;
            }

            this.customerdata.password = this.CUSTOMER_DETAIL_DATA.password;
            let groups = 1; // default is 1

            if (
                this.customerdata.groups != undefined &&
                this.CUSTOMER_DETAIL_DATA.groups.length > 0
            ) {
                groups = this.CUSTOMER_DETAIL_DATA.groups[0].id;
            }

            this.customerdata.groups = groups;
            this.customerdata.privilege =
                this.CUSTOMER_DETAIL_DATA.privilege.length > 0 ?
                this.CUSTOMER_DETAIL_DATA.privilege[0].id :
                null;
        }
    },

    computed: {
        ...mapGetters([
            "GET_SNACK_BAR",
            "CUSTOMER_DETAIL_DATA",
            "UPDATE_CUSTOMER_DATA",
            "GET_MEMBERROLECODES_DATA",
            "GET_ACCOUNT_DATA"
        ]),
        privilegeOptions: function () {
            return this.privilege.customer;
        }
    },

    methods: {
        ...mapActions([
            "ERROR_TOAST",
            "SUCCESS_TOAST",
            "ADD_CUSTOMER",
            "GET_CUSTOMER_DETAIL",
            "UPDATE_CUSTOMER",
            "UPDATE_CUSTOMER_EMAIL",
            "ON_SHOW_TOAST",
            "GET_COUNTRY_LIST",
            "ACCOUNT_PASSWORD_RESET"
        ]),

        // this.$t("customer.error_messages.email_exist")
        showError: function(msg){
            this.ON_SHOW_TOAST({
                message: this.$t(msg),
                styleType: "danger"
            });
        },
        showSuccess: function(msg){
            this.ON_SHOW_TOAST({
                message: msg,
                styleType: "success"
            });
        },
        // #615
        clickOpenModalChangeEmail: function(){
            $("#modal-change-email").modal("show");
            this.newEmail = "";
            this.oldEmail = this.customerdata.email;
        },
        // [loitt] - add validate Email empty and incorrect format
        validateEmailAll: function(field, objectName = 'this.customerdata.',  objectNameRequire = 'this.field_required.' ) {
            // use for get value : this.customer.last_name
            let exec = objectName + field

            // this.field_required.last_name
            let error_msg = objectNameRequire + field

            // Init data befor check
            eval(error_msg + " = ''")

            // ==> get value current
            let result = eval(exec)

            if (result == null || result == "") {
                eval(error_msg + " = 'common.error_msg[0].required'")
            } else {
                let isEmailValid = this.validateEmail(result)
                if(!isEmailValid){
                eval(error_msg + " = 'user.inform_modal[0].email_error'")
                }
            }

            return result;
        },

        // [loitt] - add validate Field Is Empty
        validateFieldIsEmpty: function(field, objectName = 'this.customerdata.',  objectNameRequire = 'this.field_required.' ) {

            // use for get value : this.userdata.last_name
            let exec = objectName + field

            // this.field_required.last_name
            let error_msg = objectNameRequire + field

            // Init data befor check
            eval(error_msg + " = ''")

            // ==> get value current
            let result = eval(exec)

            if (result == null || result == "") {
                eval(error_msg + " = 'common.error_msg[0].required'")
            }

            return result;

        },

        callBackToList: function(){
            let name = "Customer"
            if (typeof(this.callback) !== 'undefined'){
                name = this.callback
            }
            this.$router.push({
                name: name
            });
        },
        onOpenServices: function () {
            this.$router.push({
                name: "ServiceHistory"
            });
        },
        // onAssignService: function() {
        //   this.$router.push({
        //     name: "AssignService"
        //   })
        // },
        onCurrentService: function () {
            this.$router.push({
                name: "ServiceAssigned"
            });
        },
        CancelCustomerList: function () {
            this.callBackToList()
        },
        passwodReset: function() {
            let payload = {
                email_or_username: this.customerdata.email,
                // domain: Enum.domain
            }
            this.ACCOUNT_PASSWORD_RESET(payload).then(
                function() {
                    this.ON_SHOW_TOAST({
                    message: this.$t("customer.info_send_email", {'0': this.customerdata.email}),
                    styleType: "success"
                    });
                    // this.$router.push({ name: "PasswordResetDone" });
                }.bind(this)
            ).catch(
                function(error) {
                    this.ON_SHOW_TOAST({
                    message: error.response.data.message,
                    styleType: "danger"
                    });
                }.bind(this)
            )
        },
        showModal: function () {
            $("#modal-newpassword").modal("show");
            this.oldPassword = "";
            this.newPassword = "";
            this.confirmNewPassword = "";
            this.password_length = 0;
            this.password_typed = false;
            this.contain_lowercase = false;
            this.contain_uppercase = false;
            this.contain_number = false;
            this.valid_password_length = false;
            this.valid_password = false
        },
        onUpdatePassword: function () {
            if (this.newPassword === "" || this.oldPassword === "" || this.confirmNewPassword === "") {
                let required_title = "customer.inform_modal[0].empty_error";
                this.showInformmodal(required_title);
            } else if (this.newPassword !== this.confirmNewPassword) {
                let confirm_title = "customer.inform_modal[0].confirm_error";
                this.showInformmodal(confirm_title);
            } else if (this.valid_password == false) {
                let weakpass_title = "customer.inform_modal[0].weakpass_error";
                this.showInformmodal(weakpass_title);
            } else {
                $("#modal-newpassword").modal("hide");
                let data = {
                    id: this.customerdata.id,
                    password: this.newPassword,
                    obsoletepassword: this.oldPassword
                };
                this.UPDATE_CUSTOMER(data).then(
                    function (res) {
                        let success_title = "user.inform_modal[0].updated_success";
                        this.showInformmodal(success_title);
                    }.bind(this)
                ).catch(
                    function (error) {
                        // this.ON_SHOW_TOAST({
                        //     message: error,
                        //     styleType: "danger"
                        // })
                        let failed_title = "customer.inform_modal[0].oldpass_error"
                        this.showInformmodal(failed_title);
                    }.bind(this)
                );
            }
        },
        validateData: function () {
            let validatedResult = "OK";
            let isEmailComValid = this.validateEmail(this.customerdata.company_email)
            let isEmailRepValid = this.validateEmail(this.customerdata.representative_email)
            let isEmailCusValid = this.validateEmail(this.customerdata.email)

            for (let key in this.customerdata) {
                if (
                    key == "crmcode" ||
                    key == "country_code" ||
                    key == "company_name" ||
                    key == "company_address" ||
                    key == "company_tax_code" ||
                    key == "personal_tax_code" ||
                    key == "url_avatar" ||
                    key == "company_website" ||
                    key == "representative_name" ||
                    key == "representative_email" ||
                    key == "representative_phone" ||
                    key == "phone" ||
                    key == "company_phone" ||
                    key == "representative_identificationnumber" ||
                    key == "representative_passport" ||
                    key == "representative_position" ||
                    key == "passport" ||
                    key == "identificationnumber"
                ) {
                    // not validating 'crmcode' field

                    // validate CMND - # issue 188
                    if( key == "identificationnumber" &&
                        this.customerdata[key] !== null &&
                        this.customerdata[key] !== "") {
                            let lenIdentificationNumber = this.customerdata[key].length
                            if(!(lenIdentificationNumber == 9 || lenIdentificationNumber == 12)){
                                validatedResult = "CMND phải có chiều dài của chuỗi là 9 hoặc 12 ký tự";
                                break;
                            }
                    }

                    // validate passport - # issue 188
                    if( key == "passport" &&
                        this.customerdata[key] !== null &&
                        this.customerdata[key] !== "") {
                            let passport = this.customerdata[key].length
                            if(!(7 < passport && passport < 15)){
                                validatedResult = "Passport phải có chiều dài chuỗi lớn hơn 7 và nhỏ hơn 15";
                                break;
                            }
                    }
                    if (key == "representative_phone") {
                      if (!utils.isNull(this.customerdata['representative_phone'])) {
                        let isRepresentativePhoneValid = utils.validatePhone(this.customerdata['representative_phone'].replace(/ /g,''))
                        if (!isRepresentativePhoneValid) {
                          validatedResult = "Representative phone number is incorrect format";
                          break;
                        }
                      }
                    }
                    if (key == "company_phone") {
                      if (!utils.isNull(this.customerdata['company_phone'])) {
                        let isCompanyPhoneValid = utils.validatePhone(this.customerdata['company_phone'].replace(/ /g,''))
                        if (!isCompanyPhoneValid) {
                          validatedResult = "Company phone number is incorrect format";
                          break;
                        }
                      }
                    }
                    if (this.customerdata['phone'] != "" && this.customerdata['phone'] != null) {
                      let isPhoneValid = utils.validatePhone(this.customerdata['phone'].replace(/ /g,''))
                      if (!isPhoneValid) {
                        validatedResult = "Phone number is incorrect format";
                        break;
                      }
                    }
                }
                else if (
                    (this.customerdata[key] === null ||
                    this.customerdata[key] === "") &&
                    key != "representative_phone" &&
                    key != "company_phone" &&
                    key != "phone"
                ) {
                    validatedResult = key + " is not empty";
                    break;
                } else if (!isEmailCusValid || !isEmailRepValid || !isEmailComValid) {
                    // this.showInformmodal("customer.inform_modal[0].email_error")
                    validatedResult = "Email is not valid";
                    break;
                } else {
                    //
                }
            }
            return validatedResult;
        },
        checkForm: function() {

            let result_error = "OK"
            for (var key in this.field_required)
            {
                if(key === 'email'){
                    this.validateEmailAll(key);
                } else {
                   if(!(key === 'password' && this.$route.params.id != 0)){
                        this.validateFieldIsEmpty(key);
                    }
                }

                let key_error = this.objectNameRequire + key
                let  t_result = eval(key_error)
                if( t_result != ''){
                    result_error = t_result
                }
            }

            return result_error
        },
        SaveCustomerList: function (event) {
            this.waitingLoading(true)
            event.preventDefault();
            // [loitt] - changed validate data #266
            let result = this.checkForm(); // validateData
            if (result == "OK") {
                result = this.validateData()
            }

            if (result == "OK") {
                let groups = 1; // default is 1
                if (this.customerdata.groups != undefined) {
                    groups = this.customerdata.groups;
                }

                let data = {
                    last_login: this.timeCurrent, // need set time
                    is_superuser: false,
                    username: this.customerdata.username,
                    first_name: this.customerdata.first_name,
                    last_name: this.customerdata.last_name,
                    email: this.customerdata.email,
                    is_staff: false,
                    is_active: true,
                    date_joined: this.timeCurrent, // need set time
                    groups: [groups], // this is array
                    user_permissions: [1], // need review
                    // infor profile
                    profile: [{
                        dob: utils.formatSqlDate(this.customerdata.dob, "DD-MM-YYYY", "YYYY-MM-DD"),
                        phone: this.customerdata.phone.replace(/ /g,''),
                        gender: this.customerdata.gender,
                        customer_crm_code: this.customerdata.crmcode,
                        country_code: this.customerdata.country_code,
                        is_company: 1, // this is company
                        company_name: this.customerdata.company_name,
                        company_address: this.customerdata.company_address,
                        company_tax_code: this.customerdata.company_tax_code,
                        company_email: this.customerdata.company_email,
                        company_phone: utils.isNull(this.customerdata.company_phone)
                                        ? ""
                                        : this.customerdata.company_phone.replace(/ /g,''),
                        personal_tax_code: this.customerdata.personal_tax_code,
                        url_avatar: this.customerdata.url_avatar,

                        company_website: this.customerdata.company_website,
                        representative_name: this.customerdata.representative_name,
                        representative_email: this.customerdata.representative_email,
                        representative_phone: utils.isNull(this.customerdata.representative_phone)
                                                ? "" :
                                                this.customerdata.representative_phone.replace(/ /g,''),
                        representative_identificationnumber: this.customerdata.representative_identificationnumber,
                        representative_passport: this.customerdata.representative_passport,
                        representative_position: this.customerdata.representative_position,
                        identificationnumber: this.customerdata.identificationnumber,
                        passport: this.customerdata.passport,
                    }],
                    // privilege
                    privilege: [this.customerdata.privilege],
                    id: this.customerdata.id
                };

                if (parseInt(this.customerdata.id) == 0) {
                    data['password'] = constantsData.password_default.password
                    this.ADD_CUSTOMER(data).then(
                        function () {
                            this.waitingLoading(false)
                            this.ON_SHOW_TOAST({
                                message: this.$t("customer.info_send_email", {'0': this.customerdata.email}),
                                styleType: "success"
                            });
                            this.callBackToList()
                        }.bind(this)
                    ).catch(
                        function (error) {
                            this.waitingLoading(false)
                            this.ON_SHOW_TOAST({
                                message: error.response.data.message,
                                styleType: "danger"
                            })
                        }.bind(this)
                    );
                } else {
                    this.UPDATE_CUSTOMER(data).then(
                        function () {
                            this.waitingLoading(false)
                            this.callBackToList()
                        }.bind(this)
                    ).catch(
                        function (error) {
                            this.waitingLoading(false)
                                this.ON_SHOW_TOAST({
                                message: error.response.data.message,
                                styleType: "danger"
                            })
                        }.bind(this)
                    );
                }
            } else if (result != 'OK'){
                // let error_title = "customer.inform_modal[0].empty_error";
                //     this.showInformmodal(error_title);
                this.waitingLoading(false)
                this.ON_SHOW_TOAST({
                    message: result,
                    styleType: "danger"
                })
            } else {
                this.waitingLoading(false)
                this.ON_SHOW_TOAST({
                    message: "This password is not valid",
                    styleType: "danger"
                })
            }
        },
        isCheck: function () {
            this.customerdata.is_company = this.customerdata.is_company == 0 ? 1 : 0;
            this.ischeck = this.customerdata.is_company == 1 ? true : false;
        },
        onSave() {
            this.$refs.formsubmitbutton.click();
        },
        showInformmodal: function (title) {
            this.modal_title = title;
            $("#inform_modal").modal("show");
        },
        validatePassword: function(password) {
        this.password_length = password.length;
        if(this.password_length <= 0){
            this.field_required.password= 'common.error_msg[0].required'
            return
        }

        if (this.password_length > 7) {
                this.valid_password_length = true;
            } else {
                this.valid_password_length = false;
            }

            if (this.password_length > 0) {
                this.password_typed = true;
            } else {
                this.password_typed = false;
            }

            this.contain_lowercase = /[a-z]/.test(password);
            this.contain_uppercase = /[A-Z]/.test(password);
            this.contain_number = /\d/.test(password);

            if (
                this.contain_lowercase == true &&
                this.contain_uppercase == true &&
                this.contain_number == true &&
                this.valid_password_length == true) {
                this.valid_password = true;
            } else {
                this.valid_password = false;
            }
        },
        validateEmail: function(email){
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!pattern.test(email)){
                email = ""
                return false
            } else {
                return true
        }

    },
    waitingLoading: function(bol) {
      this.isLoading = bol;
    },

    // #615
    onUpdateEmail: function() {
      if (
        this.newEmail === "" ||
        this.oldEmail === ""
      ) {
        let required_title = "user.inform_modal[0].empty_error";
        this.showError(required_title)
      } else if (this.validateEmail(this.newEmail) == false) {
        let email_error = "user.inform_modal[0].email_error";
        this.showError(email_error)
      } else {
        $("#modal-change-email").modal("hide");
        let data = {
          id: this.customerdata.id,
          old_email: this.oldEmail,
          new_email: this.newEmail
        };
        this.UPDATE_CUSTOMER_EMAIL(data).then(
            function() {
              let success_title = this.$t("user.inform_modal[0].email_updated_success", {'0': this.oldEmail, '1': this.newEmail})
              this.customerdata.email =  this.newEmail
              this.showSuccess(success_title)
            }.bind(this)
        ).catch(
            function(error) {
              let failed_title = "Unknow"
              if(error.response.data.message.includes("email_exist_in_system"))
                  failed_title = "user.inform_modal[0].email_exist_in_system"
              this.showError(failed_title)
            }.bind(this)
        );
      }
    },
    },
    mounted() {
        let id = this.$route.params.id;

        this.GET_COUNTRY_LIST().then(
            function(res) {
                let countries = [];
                let data = res.data;
                data.forEach(c => {
                    let country = {
                        value: c.id,
                        text: c.country_name
                    }
                    countries.push(country);
                })
                this.country_list = countries
            }.bind(this)
        )

        if (parseInt(id) !== 0) {
            this.customerdata.id = id;
            this.pagetitle = "Edit Campaign";
            this.GET_CUSTOMER_DETAIL({ id: id });
            this.assignShow = false;
            this.showPasswordText = false;
        } else {
            this.customerdata.password = constantsData.password_default.password
            this.showPasswordText = true;
        }
    },
    components: {
        "lte-core-alert": LTECoreAlert,
        "date-picker": datePicker,
        loading: Loading
    }
};
</script>

<style lang="" scoped>
@media (min-width: 768px) {
    .modal-dialog {
        width: 800px;
    }
}
.lnu_container {
  display: block;
  margin: 10px auto;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.lnu_container p {
  width: 30%;
  height: auto;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 98, .8);
  background: linear-gradient(to right, #06a65a 50%, #eee 50%);
  background-size: 200% 100%;
  background-position: right;
  -webkit-transition: background .3s;
  transition: background .3s;
}
.got_lowercase,
.got_uppercase,
.got_number {
  background-position: left !important;
  color: rgba(255, 255, 255, .9) !important;
}
.show_password_length {
  display: block !important;
}
.password_length {
  padding: 2px 8px;
  position: absolute;
  top: 42px;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all .1s;
  transition: all .1s;
}
.password_length_modal {
  padding: 2px 8px;
  position: absolute;
  top: 50.3%;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all .1s;
  transition: all .1s;
}
.password_length_count {
  background: #06a65a;
  color: rgba(255, 255, 255, .9);
}

.form-group.required .control-label:after {
    color: #d00;
    position: absolute;
    margin-left: 8px;
    margin-top: -3px;
    font-family: 'FontAwesome';
    font-weight: normal;
    font-size: 9px;
    content: "\f069";
}
</style>



// WEBPACK FOOTER //
// src/views/Customer/CustomerAddCompany.vue